import axios from "axios";
export default axios.create({
  baseURL: "https://api.hirehoodapp.com/", //"https://api.hirehoodapp.com/", //https://api.hirehoodapp.com/
  responseType: 'json',
  maxContentLength: 50 * 1024 * 1024, // 50MB
  maxContentLength: 100000000,
  maxBodyLength: 1000000000
});